import { useState } from "react";
import { useAuth } from "../lib/auth";

export default function Login() {
  const { login, error } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    await login(username, password);
    setLoading(false);
  }

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit} data-testid="login-form">
        <div className="login-brand">
          <div className="login-logo">SGA</div>
          <div className="login-title">SGA Xerome</div>
          <div className="login-sub">Plataforma de Gestión Ambiental</div>
        </div>

        <div className="mb-4">
          <label className="label">Usuario o correo</label>
          <input
            className="input"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Xero o admin@demo.local"
            autoFocus
            data-testid="login-username"
          />
        </div>

        <div className="mb-4">
          <label className="label">Contraseña</label>
          <input
            type="password"
            className="input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            data-testid="login-password"
          />
        </div>

        {error && (
          <div className="mb-4" style={{
            background: "rgba(231,76,60,0.12)",
            border: "1px solid var(--danger)",
            borderRadius: 8, padding: 10, fontSize: 12, color: "var(--danger)",
          }} data-testid="login-error">
            {error}
          </div>
        )}

        <button type="submit" className="btn btn-primary w-full" disabled={loading} data-testid="login-submit">
          {loading ? <span className="spinner" /> : "Iniciar sesión"}
        </button>

        <div className="mt-6 text-xs text-dim text-center">
          v3.0 · Español MX
        </div>
      </form>
    </div>
  );
}
